export default __webpack_public_path__ + "static/media/SWN_bg.a08981cc.mov";